import {call, put, takeLatest, takeEvery, cancel} from 'redux-saga/effects'
import moment from 'moment'
import FileDownload from 'react-file-download'
import {
  getSalesSummary,
  getPaymentMethods,
  getItemSales,
  getCategorySales,
  getModifierSales,
  getDiscounts,
  getTaxes,
  getGratuities,
  getStaffs,
  getServers,
  getGrossProfit
} from 'sagas/api/sales'
import {
  REPORTS_SALES_PAGE_REQUEST,
  REPORTS_SALES_SUMMARY_REQUEST,
  REPORTS_GROSS_PROFIT_PAGE_REQUEST,
  REPORTS_GROSS_PROFIT_REQUEST,
  REPORTS_PAYMENT_METHODS_PAGE_REQUEST,
  REPORTS_PAYMENT_METHODS_REQUEST,
  REPORTS_ITEM_SALES_PAGE_REQUEST,
  REPORTS_ITEM_SALES_REQUEST,
  REPORTS_CATEGORY_SALES_PAGE_REQUEST,
  REPORTS_CATEGORY_SALES_REQUEST,
  REPORTS_MODIFIER_SALES_PAGE_REQUEST,
  REPORTS_MODIFIER_SALES_REQUEST,
  REPORTS_DISCOUNTS_PAGE_REQUEST,
  REPORTS_DISCOUNTS_REQUEST,
  REPORTS_TAXES_PAGE_REQUEST,
  REPORTS_TAXES_REQUEST,
  REPORTS_GRATUITY_PAGE_REQUEST,
  REPORTS_GRATUITY_REQUEST,
  REPORTS_COLLECTEDBY_PAGE_REQUEST,
  REPORTS_COLLECTEDBY_REQUEST,
  REPORTS_SERVEDBY_PAGE_REQUEST,
  REPORTS_SERVEDBY_REQUEST,
  REPORTS_SALES_SUMMARY_CHANGE_DATE,
  REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE,
  REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE,
  REPORTS_SALES_ITEM_SALES_CHANGE_DATE,
  REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE,
  REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE,
  REPORTS_SALES_DISCOUNTS_CHANGE_DATE,
  REPORTS_SALES_TAXES_CHANGE_DATE,
  REPORTS_SALES_GRATUITY_CHANGE_DATE,
  REPORTS_SALES_COLLECTEDBY_CHANGE_DATE,
  REPORTS_SALES_SERVEDBY_CHANGE_DATE,
  REPORTS_SALES_SUMMARY_CHANGE_OUTLET,
  REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET,
  REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET,
  REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET,
  REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET,
  REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET,
  REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET,
  REPORTS_SALES_TAXES_CHANGE_OUTLET,
  REPORTS_SALES_GRATUITY_CHANGE_OUTLET,
  REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET,
  REPORTS_SALES_SERVEDBY_CHANGE_OUTLET,
  REPORTS_SALES_EXPORT_SUMMARY,
  REPORTS_SALES_EXPORT_GROSS_PROFIT,
  REPORTS_SALES_EXPORT_PAYMENT_METHODS,
  REPORTS_SALES_EXPORT_ITEM_SALES,
  REPORTS_SALES_EXPORT_CATEGORY_SALES,
  REPORTS_SALES_EXPORT_MODIFIER_SALES,
  REPORTS_SALES_EXPORT_DISCOUNTS,
  REPORTS_SALES_EXPORT_TAXES,
  REPORTS_SALES_EXPORT_GRATUITY,
  REPORTS_SALES_EXPORT_COLECTEDBY,
  REPORTS_SALES_EXPORT_SERVEDBY
} from 'actions/reports/sales/constants'
import {
  LOGOUT
} from 'actions/constants'
import {
  salesSummaryRequest,
  setSalesSummary,
  grossProfitRequest,
  setGrossProfit,
  paymentMethodsRequest,
  setPaymentMethods,
  itemSalesRequest,
  setItemSales,
  categorySalesRequest,
  setCategorySales,
  modifierSalesRequest,
  setModifierSales,
  discountsRequest,
  setDiscounts,
  taxesRequest,
  setTaxes,
  gratuityRequest,
  setGratuity,
  collectedByRequest,
  setCollectedBy,
  servedByRequest,
  setServedBy,
  setOutlets,
  reportsShowLoadingSpinner
} from 'actions/reports/sales'
import * as apiOutlets from 'api/outlets'
import {setCurrentOutlet} from 'actions/outlet'
import { getFilteredDate } from 'sagas/api/get-filtered-date'
import {getProfile} from 'sagas/api/profile'
import {loginOutlet} from 'sagas/api/login'
import * as apiReport from 'api/sales'
import * as actNotif from 'actions/notifications'
import * as actGetExportedFile from 'actions/get-exported-file'
import * as actActionBar from 'actions/actionBar'
import {initialize} from 'redux-form'
import * as action from 'actions'
import * as mpReportSummary from 'mixpanel/reports/summary'
import * as mpReportPaymentMethod from 'mixpanel/reports/paymentMethods'
import * as mpReportItemSales from 'mixpanel/reports/itemSales'
import * as mpReportCategorySales from 'mixpanel/reports/categorySales'
import * as mpReportModifierSales from 'mixpanel/reports/modifierSales'
import * as mpReportTaxes from 'mixpanel/reports/taxes'
import * as mpDiscount from 'mixpanel/reports/discounts'
import * as mpReportGratuity from 'mixpanel/reports/gratuity'
import * as mpReportCollected from 'mixpanel/reports/collected'
import * as mpReportServedBy from 'mixpanel/reports/served'
import * as mpGrossProfit from 'mixpanel/reports/grossProfit'
import * as act from 'actions/index'

function * fillForm (outletIds, startDate, endDate) {
  yield put(initialize('search', {
    outlet: outletIds,
    date: {startDate, endDate}
  }))
}

export function * reportsSalesPageRequestFlow (request) {
  try {
    yield put(setSalesSummary([]))
    // set false by salessummary request saga
    yield put(reportsShowLoadingSpinner(true))

    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)

    yield put(salesSummaryRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
    mpReportSummary.reportSummaryStart({
      outletIds: profile.outlet_id,
      startDate: moment(filteredDate.start_date),
      endDate: moment(filteredDate.end_date)
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getSalesSummaryFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let salesSummary = yield call(getSalesSummary, {start, end})

  if (salesSummary) {
    yield put(setSalesSummary(salesSummary))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * grossProfitPageRequestFlow (request) {
  try {
    yield put(setGrossProfit([]))
    // set false by salessummary request saga
    yield put(reportsShowLoadingSpinner(true))

    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)

    yield put(grossProfitRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getGrossProfitFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let grossProfit = yield call(getGrossProfit, {start, end})

  if (grossProfit) {
    yield put(setGrossProfit(grossProfit))
    mpGrossProfit.reportGrossProfitStart({grossProfit})
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * paymentMethodsPageRequestFlow (request) {
  try {
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())

    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)

    yield put(paymentMethodsRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
    mpReportPaymentMethod.reportsPaymentMethodsStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getPaymentMethodsFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let paymentMethods = yield call(getPaymentMethods, {start, end})

  if (paymentMethods) {
    yield put(setPaymentMethods(paymentMethods))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * itemSalesPageRequestFlow (request) {
  try {
    yield put(setItemSales([]))
    // set false by itemsales request saga
    yield put(reportsShowLoadingSpinner(true))

    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)
    mpReportItemSales.reportsItemSalesStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
    yield put(itemSalesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getItemSalesFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let itemSales = yield call(getItemSales, {start, end})

  if (itemSales) {
    yield put(setItemSales(itemSales))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * categorySalesPageRequestFlow (request) {
  try {
    yield put(setCategorySales([]))
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)

    yield put(categorySalesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
    mpReportCategorySales.reportsCategorySalesStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getCategorySalesFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let categorySales = yield call(getCategorySales, {start, end})

  if (categorySales) {
    yield put(setCategorySales(categorySales))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * modifierSalesPageRequestFlow (request) {
  try {
    yield put(setModifierSales([]))
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)
    mpReportModifierSales.reportsModifierSalesStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
    yield put(modifierSalesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getModifierSalesFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let modifierSales = yield call(getModifierSales, {start, end})

  if (modifierSales) {
    yield put(setModifierSales(modifierSales))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * discountsPageRequestFlow (request) {
  try {
    yield put(setDiscounts([]))
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)
    mpDiscount.reportsDiscountStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })

    let outletIds = profile.outlet_id.join(',')
    yield put(discountsRequest({startDate: startDateFormatted, endDate: endDateFormatted, outletIds}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getDiscountsFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let {outletIds} = request.payload
  let discounts = yield call(getDiscounts, {start, end, outletIds})

  if (discounts) {
    yield put(setDiscounts(discounts))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * taxesPageRequestFlow () {
  try {
    yield put(setTaxes([]))
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)
    mpReportTaxes.reportsTaxStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
    yield put(taxesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getTaxesFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let taxes = yield call(getTaxes, {start, end})

  if (taxes) {
    yield put(setTaxes(taxes))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * gratuityPageRequestFlow (request) {
  try {
    yield put(setGratuity([]))
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)

    yield put(gratuityRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
    mpReportGratuity.reportsGratuityStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getGratuitiesFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let gratuities = yield call(getGratuities, {start, end})

  if (gratuities) {
    yield put(setGratuity(gratuities))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * collectedByPageRequestFlow () {
  try {
    yield put(setCollectedBy([]))
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)

    yield put(collectedByRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
    mpReportCollected.reportCollectedStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getStaffsFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let staffs = yield call(getStaffs, {start, end})

  if (staffs) {
    yield put(setCollectedBy(staffs))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * servedByPageRequestFlow (request) {
  try {
    yield put(setServedBy([]))
    yield put(reportsShowLoadingSpinner(true))
    yield put(action.showProgressBar())
    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set actionbar state - used for connecting nav outlet and redux form value
    yield put(actActionBar.setOutlets(resOutlets.data))
    yield put(actActionBar.setSelectedOutletIds(profile.outlet_id))

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)
    mpReportServedBy.reportServedStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
    yield put(servedByRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getServersFlow (request) {
  yield put(reportsShowLoadingSpinner(true))
  let start = request.payload.startDate
  let end = request.payload.endDate
  let servers = yield call(getServers, {start, end})

  if (servers) {
    yield put(setServedBy(servers))
  }
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeDateSalesSummaryFlow (request) {
  // will be set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(salesSummaryRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateGrossProfitFlow (request) {
  // will be set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(grossProfitRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDatePaymentMethodsFlow (request) {
  // will be set false by paymentMethods request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(paymentMethodsRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateItemSalesFlow (request) {
  yield put(setItemSales([]))
  // will be set false by itemSales request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(itemSalesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateCategorySalesFlow (request) {
  yield put(setCategorySales([]))
  // will be set false by categorySales request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(categorySalesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateModifierSalesFlow (request) {
  yield put(setModifierSales([]))
  // will be set false by modifierSales request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(modifierSalesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateDiscountsFlow (request) {
  yield put(setDiscounts([]))
  // will be set false by discounts request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate, outletIds} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(discountsRequest({startDate: startDateFormatted, endDate: endDateFormatted, outletIds}))
}

export function * changeDateTaxesFlow (request) {
  yield put(setTaxes([]))
  // will be set false by taxes request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(taxesRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateGratuityFlow (request) {
  yield put(setGratuity([]))
  // will be set false by gratuities request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(gratuityRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateCollectedByFlow (request) {
  yield put(setCollectedBy([]))
  // will be set false by collectedBy request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(collectedByRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeDateServedByFlow (request) {
  yield put(setServedBy([]))
  // will be set false by servedBy request saga
  yield put(reportsShowLoadingSpinner(true))

  let {startDate, endDate} = request.payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')
  yield put(servedByRequest({startDate: startDateFormatted, endDate: endDateFormatted}))
}

export function * changeOutletSalesSummaryFlow (request) {
  yield put(setSalesSummary([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const salesSummaryData = yield call(apiReport.getSalesSummary, {start: startDateFormatted, end: endDateFormatted})
  yield put(setSalesSummary(salesSummaryData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletGrossProfitFlow (request) {
  yield put(setGrossProfit([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const grossProfitData = yield call(apiReport.getGrossProfit, {start: startDateFormatted, end: endDateFormatted})
  yield put(setGrossProfit(grossProfitData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletPaymentMethodsFlow (request) {
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const paymentMethodsData = yield call(apiReport.getPaymentMethods, {start: startDateFormatted, end: endDateFormatted})
  yield put(setPaymentMethods(paymentMethodsData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletItemSalesFlow (request) {
  yield put(setItemSales([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const itemSalesData = yield call(apiReport.getItemSales, {start: startDateFormatted, end: endDateFormatted})
  yield put(setItemSales(itemSalesData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletCategorySalesFlow (request) {
  yield put(setCategorySales([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const categorySalesData = yield call(apiReport.getCategorySales, {start: startDateFormatted, end: endDateFormatted})
  yield put(setCategorySales(categorySalesData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletModifierSalesFlow (request) {
  yield put(setModifierSales([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const modifierSalesData = yield call(apiReport.getModifierSales, {start: startDateFormatted, end: endDateFormatted})
  yield put(setModifierSales(modifierSalesData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletDiscountsFlow (request) {
  yield put(setDiscounts([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const discountsData = yield call(apiReport.getDiscounts, {start: startDateFormatted, end: endDateFormatted, outletIds: outletIds.join(',')})
  yield put(setDiscounts(discountsData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletTaxesFlow (request) {
  yield put(setTaxes([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const taxesData = yield call(apiReport.getTaxes, {start: startDateFormatted, end: endDateFormatted})
  yield put(setTaxes(taxesData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletGratuityFlow (request) {
  yield put(setGratuity([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const gratuityData = yield call(apiReport.getGratuities, {start: startDateFormatted, end: endDateFormatted})
  yield put(setGratuity(gratuityData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * changeOutletCollectedByFlow (request) {
  yield put(setCollectedBy([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  try {
    let {payload} = request
    let {outletIds, startDate, endDate} = payload

    yield call(loginOutlet, {id: outletIds})
    let currentOutlet = yield call(getProfile)
    yield put(setCurrentOutlet(currentOutlet))
    yield call(fillForm, outletIds, startDate, endDate)
    let startDateFormatted = startDate.format('D/M/YYYY')
    let endDateFormatted = endDate.format('D/M/YYYY')
    const staffData = yield call(apiReport.getStaffs, {start: startDateFormatted, end: endDateFormatted})
    yield put(setCollectedBy(staffData.data))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(reportsShowLoadingSpinner(false))
  }
}

export function * changeOutletServedByFlow (request) {
  yield put(setServedBy([]))
  // set false by salessummary request saga
  yield put(reportsShowLoadingSpinner(true))

  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  let currentOutlet = yield call(getProfile)
  yield put(setCurrentOutlet(currentOutlet))
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')
  const serverData = yield call(apiReport.getServers, {start: startDateFormatted, end: endDateFormatted})
  yield put(setServedBy(serverData.data))
  yield put(reportsShowLoadingSpinner(false))
}

export function * exportSummaryFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportSummary, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'sales summary'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}
export function * exportGrossProfitFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportGrossProfit, query)
    // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'sales summary'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportPaymentMethodsFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportPaymentMethod, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'payment methods'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportItemSalesFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportItemSales, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'item sales'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportCategorySalesFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportCategorySales, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'category sales'))
  } catch (e) {
    yield put(actNotif.error(e.message))
  }
}

export function * exportModifierSalesFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportModifierSales, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'modifier sales'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportDiscountFlow (request) {
  let {query, filename} = request.payload
  try {
    yield put(act.showLoadingSpinner(true))
    let {data} = yield call(apiReport.exportDiscounts, query)
    yield put(act.showLoadingSpinner(false))
    FileDownload(data, `${filename}.csv`)
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportTaxesFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportTaxes, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'taxes'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportGratuityFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportGratuity, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'gratuity'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportColectedByFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportColectedBy, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'collected by'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * exportServedByFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(apiReport.exportServedBy, query)
      // fetch the result
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'served by'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * cancelAction (cancelledTasks, request) {
  yield cancel(...cancelledTasks)
}

export default function * reportsSalesSaga () {
  const pageRequestTask = yield takeLatest(REPORTS_SALES_PAGE_REQUEST, reportsSalesPageRequestFlow)
  const getSalesSummaryTask = yield takeLatest(REPORTS_SALES_SUMMARY_REQUEST, getSalesSummaryFlow)
  const grossProfitPageRequestTask = yield takeLatest(REPORTS_GROSS_PROFIT_PAGE_REQUEST, grossProfitPageRequestFlow)
  const getSalesGrossProfitTask = yield takeLatest(REPORTS_GROSS_PROFIT_REQUEST, getGrossProfitFlow)
  const paymentMethodsPageRequestTask = yield takeLatest(REPORTS_PAYMENT_METHODS_PAGE_REQUEST, paymentMethodsPageRequestFlow)
  const getPaymentMethodsTask = yield takeLatest(REPORTS_PAYMENT_METHODS_REQUEST, getPaymentMethodsFlow)
  const itemSalesPageReqTask = yield takeLatest(REPORTS_ITEM_SALES_PAGE_REQUEST, itemSalesPageRequestFlow)
  const itemSalesReqTask = yield takeLatest(REPORTS_ITEM_SALES_REQUEST, getItemSalesFlow)
  const categorySalesPageReqTask = yield takeLatest(REPORTS_CATEGORY_SALES_PAGE_REQUEST, categorySalesPageRequestFlow)
  const getCategorySalesTask = yield takeLatest(REPORTS_CATEGORY_SALES_REQUEST, getCategorySalesFlow)
  const modifierSalesPageReqTask = yield takeLatest(REPORTS_MODIFIER_SALES_PAGE_REQUEST, modifierSalesPageRequestFlow)
  const modifierSalesReqTask = yield takeLatest(REPORTS_MODIFIER_SALES_REQUEST, getModifierSalesFlow)
  const discountPageReqTask = yield takeLatest(REPORTS_DISCOUNTS_PAGE_REQUEST, discountsPageRequestFlow)
  const discountReqTask = yield takeLatest(REPORTS_DISCOUNTS_REQUEST, getDiscountsFlow)
  const taxPagReqTask = yield takeLatest(REPORTS_TAXES_PAGE_REQUEST, taxesPageRequestFlow)
  const taxReqTask = yield takeLatest(REPORTS_TAXES_REQUEST, getTaxesFlow)
  const gratuityPagReqTask = yield takeLatest(REPORTS_GRATUITY_PAGE_REQUEST, gratuityPageRequestFlow)
  const gratuityReqTask = yield takeLatest(REPORTS_GRATUITY_REQUEST, getGratuitiesFlow)
  const collectedByPageReqTask = yield takeLatest(REPORTS_COLLECTEDBY_PAGE_REQUEST, collectedByPageRequestFlow)
  const collectedByReqTask = yield takeLatest(REPORTS_COLLECTEDBY_REQUEST, getStaffsFlow)
  const servedByPageReqTask = yield takeLatest(REPORTS_SERVEDBY_PAGE_REQUEST, servedByPageRequestFlow)
  const servedByReqTask = yield takeLatest(REPORTS_SERVEDBY_REQUEST, getServersFlow)

  const changeDateSalesSummaryTask = yield takeLatest(REPORTS_SALES_SUMMARY_CHANGE_DATE, changeDateSalesSummaryFlow)
  const changeDateGrossProfitTask = yield takeLatest(REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE, changeDateGrossProfitFlow)
  const changeDatePaymentMethodsTask = yield takeLatest(REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE, changeDatePaymentMethodsFlow)
  const changeDateItemSalesTask = yield takeLatest(REPORTS_SALES_ITEM_SALES_CHANGE_DATE, changeDateItemSalesFlow)
  const changeDateCategorySalesTask = yield takeLatest(REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE, changeDateCategorySalesFlow)
  const changeDateModifierSalesTask = yield takeLatest(REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE, changeDateModifierSalesFlow)
  const changeDateDiscountTask = yield takeLatest(REPORTS_SALES_DISCOUNTS_CHANGE_DATE, changeDateDiscountsFlow)
  const changeDateTaxTask = yield takeLatest(REPORTS_SALES_TAXES_CHANGE_DATE, changeDateTaxesFlow)
  const changeDateGratuityTask = yield takeLatest(REPORTS_SALES_GRATUITY_CHANGE_DATE, changeDateGratuityFlow)
  const changeDateCollectedByTask = yield takeLatest(REPORTS_SALES_COLLECTEDBY_CHANGE_DATE, changeDateCollectedByFlow)
  const changeDateServedByTask = yield takeLatest(REPORTS_SALES_SERVEDBY_CHANGE_DATE, changeDateServedByFlow)

  const changeOutletSalesSummaryTask = yield takeLatest(REPORTS_SALES_SUMMARY_CHANGE_OUTLET, changeOutletSalesSummaryFlow)
  const changeOutletGrossProfitTask = yield takeLatest(REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET, changeOutletGrossProfitFlow)
  const changeOutletPaymentMethodsTask = yield takeLatest(REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET, changeOutletPaymentMethodsFlow)
  const changeOutletItemSalesTask = yield takeLatest(REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET, changeOutletItemSalesFlow)
  const changeOutletCategorySalesTask = yield takeLatest(REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET, changeOutletCategorySalesFlow)
  const changeOutletModifierSalesTask = yield takeLatest(REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET, changeOutletModifierSalesFlow)
  const changeOutletDiscountTask = yield takeLatest(REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET, changeOutletDiscountsFlow)
  const changeOutletTaxTask = yield takeLatest(REPORTS_SALES_TAXES_CHANGE_OUTLET, changeOutletTaxesFlow)
  const changeOutletGratuityTask = yield takeLatest(REPORTS_SALES_GRATUITY_CHANGE_OUTLET, changeOutletGratuityFlow)
  const changeOutletCollectedByTask = yield takeLatest(REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET, changeOutletCollectedByFlow)
  const changeOutletServedByTask = yield takeLatest(REPORTS_SALES_SERVEDBY_CHANGE_OUTLET, changeOutletServedByFlow)

  const exportSummaryTask = yield takeLatest(REPORTS_SALES_EXPORT_SUMMARY, exportSummaryFlow)
  const exportGrossProfitTask = yield takeLatest(REPORTS_SALES_EXPORT_GROSS_PROFIT, exportGrossProfitFlow)
  const exportPaymentMethodTask = yield takeLatest(REPORTS_SALES_EXPORT_PAYMENT_METHODS, exportPaymentMethodsFlow)
  const exportItemSalesTask = yield takeLatest(REPORTS_SALES_EXPORT_ITEM_SALES, exportItemSalesFlow)
  const exportCategorySalesTask = yield takeLatest(REPORTS_SALES_EXPORT_CATEGORY_SALES, exportCategorySalesFlow)
  const exportModifierSalesTask = yield takeLatest(REPORTS_SALES_EXPORT_MODIFIER_SALES, exportModifierSalesFlow)
  const exportDiscountsTask = yield takeLatest(REPORTS_SALES_EXPORT_DISCOUNTS, exportDiscountFlow)
  const exportTaxesTask = yield takeLatest(REPORTS_SALES_EXPORT_TAXES, exportTaxesFlow)
  const exportGratuityTask = yield takeLatest(REPORTS_SALES_EXPORT_GRATUITY, exportGratuityFlow)
  const exportCollectedByTask = yield takeLatest(REPORTS_SALES_EXPORT_COLECTEDBY, exportColectedByFlow)
  const exportServedByTask = yield takeLatest(REPORTS_SALES_EXPORT_SERVEDBY, exportServedByFlow)

  yield takeEvery(LOGOUT, cancelAction, [
    pageRequestTask,
    getSalesSummaryTask,

    grossProfitPageRequestTask,
    getSalesGrossProfitTask,
    getPaymentMethodsTask,
    paymentMethodsPageRequestTask,

    itemSalesPageReqTask,
    itemSalesReqTask,

    categorySalesPageReqTask,
    getCategorySalesTask,

    modifierSalesPageReqTask,
    modifierSalesReqTask,

    discountPageReqTask,
    discountReqTask,

    taxPagReqTask,
    taxReqTask,

    gratuityPagReqTask,
    gratuityReqTask,

    collectedByPageReqTask,
    collectedByReqTask,

    servedByPageReqTask,
    servedByReqTask,

    changeDateSalesSummaryTask,
    changeDateGrossProfitTask,
    changeDatePaymentMethodsTask,
    changeDateItemSalesTask,
    changeDateCategorySalesTask,
    changeDateModifierSalesTask,
    changeDateDiscountTask,
    changeDateGratuityTask,
    changeDateTaxTask,
    changeDateCollectedByTask,
    changeDateServedByTask,

    changeOutletSalesSummaryTask,
    changeOutletGrossProfitTask,
    changeOutletPaymentMethodsTask,
    changeOutletItemSalesTask,
    changeOutletCategorySalesTask,
    changeOutletModifierSalesTask,
    changeOutletDiscountTask,
    changeOutletTaxTask,
    changeOutletGratuityTask,
    changeOutletCollectedByTask,
    changeOutletServedByTask,

    exportSummaryTask,
    exportGrossProfitTask,
    exportPaymentMethodTask,
    exportItemSalesTask,
    exportCategorySalesTask,
    exportModifierSalesTask,
    exportDiscountsTask,
    exportTaxesTask,
    exportGratuityTask,
    exportCollectedByTask,
    exportServedByTask
  ])
}



// WEBPACK FOOTER //
// ./app/sagas/reports/sales.js